<div
  class="container"
  [ngClass]="to?.className === 'xilo-input' ? 'form-row' : 'intake-form'"
>
  <formly-field
    *ngFor="let step of field.fieldGroup; let index = index; let last = last"
    [ngClass]="fieldClasses(step)"
    [ngStyle]="fieldStyle(step)"
    [field]="step"
  ></formly-field>
</div>
